<template>
  <div class="drink-volume">
    <!-- 进度条 -->
    <div class="circle-box">
      <van-circle
        :value="volume"
        :rate="100"
        layer-color="#d0f2ff"
        color="#00d6c1"
        size="3.4rem"
        :stroke-width="72" />
      <div class="center-info">
        <div class="title">今日饮水量</div>
        <div class="wechatNumber">{{info.drink_amount}}</div>
        <div class="unit">（{{info.drink_unit}}）</div>
      </div>
    </div>
    <!-- 右侧信息 -->
    <div class="right-info">
      <div class="frequency-number wechatNumber">{{info.drink_count}}</div>
      <div class="frequency-title">今日饮水次数</div>
      <div class="two-tool">
        <div class="tool-item" @click="OpenPage">
          <img :src="IconTool" class="lef-icon" />
          <div class="title">水质报告</div>
          <img :src="IconRight" class="right-icon" />
        </div>
        <div class="tool-item" @click="$nav('Common.Ranking', {id: $route.query.id})">
          <img :src="IconStar" class="lef-icon" />
          <div class="title">查看排名</div>
          <img :src="IconRight" class="right-icon" />
        </div>
      </div>
    </div>
    <!-- <div id="handout_wrap_inner"></div> -->
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    computed: {
      volume () {
        return this.info.drink_percent || 0
      },
      ...SetImage(['IconStar', 'IconTool', 'IconRight'])
    },
    methods: {
      OpenPage () {
        if (this.info.water_report) {
          let appVersion = window.navigator.appVersion
          if (appVersion.indexOf('Android') !== -1) {
            console.log('OpenPage')
            this.$emit('openPdf', this.info.water_report)
            return
          }
          window.location.href = this.info.water_report
        } else {
          this.$ShowConfirm(
            '暂无水质报告',
            {
              title: '温馨提示',
              showCancel: false,
              confirmText: '我知道了'
            }
          )
        }
      }
    },
    props: {
      info: {
        type: Object,
        default: () => ({
          drink_percent: 0
        })
      }
    },
    created () {
      // this.info.water_report = pdf.createLoadingTask(this.info.water_report)
    }
  }
</script>

<style lang="less" scoped>
  .drink-volume {
    .pl(.62rem);
    .mb(.6rem);
    display: flex;
    .circle-box {
      position: relative;
      .mr(.5rem);
      .center-info {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .flex-ccc();
        .title {
          .fz(.28rem);
          .c(#666);
          .mb(.23rem);
        }
        .wechatNumber {
          .fz(.7rem);
          .c(#007dd5);
          .mb(.24rem);
        }
        .unit {
          .fz(.28rem);
          .c(#666);
        }
      }
    }
    .right-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      .frequency-number {
        text-align: center;
        .pt(.35rem);
        .fz(.5rem);
        .c(#007dd5);
        .mb(.27rem);
      }
      .frequency-title {
        .fz(.28rem);
        .c(#666);
        text-align: center;
        .mb(auto);
      }
      .two-tool {
        border-left: 1px solid #e5e5e5;
        .tool-item {
          display: flex;
          justify-content: center;
          align-items: center;
          .c(#ffc000);
          &:first-child {
            .c(#00b0f4);
            .mb(.3rem);
          }
          .lef-icon {
            .w(.47rem);
            .h(.47rem);
            .mr(.19rem);
          }
          .title {
            .fz(.24rem);
            .mr(.1rem);
          }
          .right-icon {
            .w(.12rem);
            .h(.2rem);
          }
        }
      }
    }
  }
</style>
